import React from 'react';
import { BrowserRouter,Routes,Route,Navigate } from 'react-router-dom';
import {AppProvider,useApp} from './context/AppContext';
import Layout from './components/common/Layout';
import ScrollToTop from './components/common/ScrollToTop';
import FeaturedClubsBadges from './components/ui/FeaturedClubsBadges';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import RecuperarPassword from './pages/RecuperarPassword';
import ResetPassword from './pages/ResetPassword';
import Registro from './pages/Registro';
import Inicio from './pages/Inicio';
import Directorio from './pages/Directorio';
import PublicProfile from './pages/PublicProfile';
import Academia from './pages/Academia';
import Clubs from './pages/Clubs';
import Eventos from './pages/Eventos';
import ClubDetail from './pages/ClubDetail';
import EventDetail from './pages/EventDetail';
import MyProfile from './pages/MyProfile';
import AdminQueue from './pages/AdminQueue';
import Insignias from './pages/Insignias';
import PublicNegocio from './pages/PublicNegocio';

// Explicit protection wrapper to instantly redirect logged-out users
const ProtectedRoute=({children})=> {
  const {isAuthenticated}=useApp();
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  } 
  return children;
};

function AppContent() {
  const {isAuthenticated, authLoading}=useApp();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-4 border-[#74ACDF] border-t-transparent animate-spin" />
      </div>
    );
  }
  
  return ( 
    <BrowserRouter> 
      <ScrollToTop />
      <Layout> 
        <Routes> 
          {/* Public Routes */} 
          <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" replace />} /> 
          <Route path="/recuperar-password" element={!isAuthenticated ? <RecuperarPassword /> : <Navigate to="/" replace />} /> 
          <Route path="/reset-password" element={<ResetPassword />} /> 
          <Route path="/registro" element={!isAuthenticated ? <Registro /> : <Navigate to="/" replace />} /> 
          <Route path="/registro/:inviteCode" element={!isAuthenticated ? <Registro /> : <Navigate to="/" replace />} /> 
          <Route path="/invitacion/:inviteCode" element={<Landing />} /> 
          <Route path="/negocio/:slug" element={<PublicNegocio />} /> 
          <Route path="/" element={isAuthenticated ? <Inicio /> : <Landing />} /> 
          
          {/* Protected Routes */} 
          <Route path="/directorio" element={<ProtectedRoute><Directorio /></ProtectedRoute>} /> 
          <Route path="/miembro/:id" element={<ProtectedRoute><PublicProfile /></ProtectedRoute>} /> 
          <Route path="/academia" element={<ProtectedRoute><Academia /></ProtectedRoute>} /> 
          <Route path="/clubs" element={<ProtectedRoute><Clubs /></ProtectedRoute>} /> 
          <Route path="/eventos" element={<ProtectedRoute><Eventos /></ProtectedRoute>} /> 
          <Route path="/club/:id" element={<ProtectedRoute><ClubDetail /></ProtectedRoute>} /> 
          <Route path="/evento/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} /> 
          <Route path="/perfil" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} /> 
          <Route path="/admin" element={<ProtectedRoute><AdminQueue /></ProtectedRoute>} /> 
          <Route path="/insignias" element={<ProtectedRoute><Insignias /></ProtectedRoute>} /> 
          
          {/* Catch-all fallback: redirect to home */} 
          <Route path="*" element={<Navigate to="/" replace />} /> 
        </Routes> 
        
        {/* Global Floating Badges - Self-manages visibility based on route */} 
        <FeaturedClubsBadges /> 
      </Layout> 
    </BrowserRouter> 
  );
} 

function App() {
  return ( 
    <AppProvider> 
      <AppContent /> 
    </AppProvider> 
  );
}

export default App;